import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/AdminLayout';
import { Save, Trash2, Edit2, X, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const CMSSolutions = () => {
  const [solutions, setSolutions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    slug: '',
    title: '',
    subtitle: '',
    description: '',
    hero_image: '',
    benefits: '',
    cta_text: 'Demander un devis'
  });

  useEffect(() => {
    fetchSolutions();
  }, []);

  const fetchSolutions = async () => {
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const token = localStorage.getItem('admin_token');
      
      const response = await fetch(`${BACKEND_URL}/api/admin/solutions`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setSolutions(data);
      }
    } catch (error) {
      toast.error('Erreur lors du chargement');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (solution) => {
    setEditingId(solution.id);
    const benefitsText = Array.isArray(solution.benefits) 
      ? solution.benefits.join('\n') 
      : (solution.benefits || '');
    setFormData({
      slug: solution.slug || '',
      title: solution.title || '',
      subtitle: solution.subtitle || '',
      description: solution.description || '',
      hero_image: solution.hero_image || '',
      benefits: benefitsText,
      cta_text: solution.cta_text || 'Demander un devis'
    });
  };

  const handleCancel = () => {
    setEditingId(null);
    setFormData({
      slug: '',
      title: '',
      subtitle: '',
      description: '',
      hero_image: '',
      benefits: '',
      cta_text: 'Demander un devis'
    });
  };

  const handleSave = async () => {
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const token = localStorage.getItem('admin_token');
      
      const benefitsArray = formData.benefits
        .split('\n')
        .map(b => b.trim())
        .filter(b => b !== '');
      
      const url = `${BACKEND_URL}/api/admin/solutions/${editingId}`;
      
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          ...formData,
          benefits: benefitsArray
        })
      });
      
      if (response.ok) {
        toast.success('Solution mise à jour !');
        handleCancel();
        fetchSolutions();
      } else {
        toast.error('Erreur lors de la sauvegarde');
      }
    } catch (error) {
      toast.error('Erreur réseau');
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '48px' }}>
          <Loader2 size={32} className="animate-spin" />
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div style={{ maxWidth: '1000px' }}>
        <div style={{ marginBottom: '32px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '8px' }}>
            Pages Solutions
          </h1>
          <p style={{ color: '#666' }}>Gérez le contenu de vos pages solutions</p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {solutions.map(solution => (
            <div 
              key={solution.id} 
              style={{ 
                background: 'white', 
                borderRadius: '12px', 
                padding: '24px',
                border: editingId === solution.id ? '2px solid var(--brand-primary)' : '1px solid #eee'
              }}
            >
              {editingId === solution.id ? (
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                    <h3 style={{ fontSize: '18px', fontWeight: '600' }}>Modifier: {solution.title}</h3>
                    <button onClick={handleCancel} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                      <X size={20} />
                    </button>
                  </div>
                  
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                    <div>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>Slug</label>
                      <input
                        value={formData.slug}
                        onChange={(e) => setFormData({...formData, slug: e.target.value})}
                        style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '6px' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>Titre</label>
                      <input
                        value={formData.title}
                        onChange={(e) => setFormData({...formData, title: e.target.value})}
                        style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '6px' }}
                      />
                    </div>
                  </div>

                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>Sous-titre</label>
                    <input
                      value={formData.subtitle}
                      onChange={(e) => setFormData({...formData, subtitle: e.target.value})}
                      style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '6px' }}
                    />
                  </div>

                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>Description</label>
                    <textarea
                      value={formData.description}
                      onChange={(e) => setFormData({...formData, description: e.target.value})}
                      rows={4}
                      style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '6px', resize: 'vertical' }}
                    />
                  </div>

                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>URL Image Hero</label>
                    <input
                      value={formData.hero_image}
                      onChange={(e) => setFormData({...formData, hero_image: e.target.value})}
                      style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '6px' }}
                    />
                  </div>

                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>Avantages (un par ligne)</label>
                    <textarea
                      value={formData.benefits}
                      onChange={(e) => setFormData({...formData, benefits: e.target.value})}
                      rows={5}
                      style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '6px', resize: 'vertical' }}
                      placeholder="Économies jusqu'à 70%&#10;Installation rapide&#10;Garantie 25 ans"
                    />
                  </div>

                  <div style={{ marginBottom: '24px' }}>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>Texte du bouton</label>
                    <input
                      value={formData.cta_text}
                      onChange={(e) => setFormData({...formData, cta_text: e.target.value})}
                      style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '6px' }}
                    />
                  </div>

                  <div style={{ display: 'flex', gap: '12px' }}>
                    <button
                      onClick={handleSave}
                      style={{
                        padding: '12px 24px',
                        background: 'var(--brand-primary)',
                        color: 'var(--brand-dark)',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}
                    >
                      <Save size={18} /> Sauvegarder
                    </button>
                    <button
                      onClick={handleCancel}
                      style={{
                        padding: '12px 24px',
                        background: '#f0f0f0',
                        color: '#333',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer'
                      }}
                    >
                      Annuler
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                  <div>
                    <h3 style={{ fontSize: '20px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '4px' }}>
                      {solution.title}
                    </h3>
                    <p style={{ color: '#666', marginBottom: '8px' }}>{solution.subtitle}</p>
                    <p style={{ fontSize: '14px', color: '#999' }}>URL: /solutions/{solution.slug}</p>
                  </div>
                  <button
                    onClick={() => handleEdit(solution)}
                    style={{
                      padding: '10px 16px',
                      background: 'var(--brand-dark)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    <Edit2 size={16} /> Modifier
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default CMSSolutions;
